import { render } from "./CrudTable.vue?vue&type=template&id=bb35f13c&ts=true"
import script from "./CrudTable.vue?vue&type=script&lang=ts"
export * from "./CrudTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/crud/infrastructure/CrudTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb35f13c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb35f13c', __exports__)) {
    api.reload('bb35f13c', __exports__)
  }
  
  module.hot.accept("./CrudTable.vue?vue&type=template&id=bb35f13c&ts=true", () => {
    api.rerender('bb35f13c', render)
  })

}


export default __exports__